module.exports = __webpack_public_path__ + "img/explore-japan-Tashii-Designs.a5d2adb8.png";